// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { addCategory } from "../../Slice/Category/categorySlice";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Select from "react-select";
// import { getData } from "../../services/FetchNodeServices";

// const AddCategory = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { loading } = useSelector((state) => state.category);

//   const [productList, setProductList] = useState([]);
//   const [active, setActive] = useState(false);

//   const [data, setData] = useState({
//     categoryname: "",
//     metaTagTitle: "",
//     metaTagDescription: "",
//     metaTagKeywords: "",
//     keywords: "",
//     image: null,
//     thumbnail: null,
//     productId: [], // for linked products
//   });

//   // Handle input changes (text)
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setData((prev) => ({ ...prev, [name]: value }));
//   };

//   // Handle file/image uploads
//   const handleFileChange = (e) => {
//     const { name, files } = e.target;
//     if (files.length) {
//       const file = files[0];
//       if (validateImage(file, name)) {
//         setData((prev) => ({ ...prev, [name]: file }));
//       }
//     }
//   };

//   const validateImage = (file, label) => {
//     if (!file) {
//       toast.error(`Please select a ${label}`);
//       return false;
//     }
//     if (file.size > 2 * 1024 * 1024) {
//       toast.error(`${label} must be under 2MB`);
//       return false;
//     }
//     return true;
//   };


//   // Submit form
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const requiredFields = [
//       "categoryname",
//       "metaTagTitle",
//       "metaTagDescription",
//       "metaTagKeywords",
//       "keywords",
//     ];

//     for (let field of requiredFields) {
//       if (!data[field]) {
//         toast.error("Please fill all required fields");
//         return;
//       }
//     }

//     if (!validateImage(data.image, "Category Banner Image")) return;
//     if (!validateImage(data.thumbnail, "Category Thumbnail Image")) return;

//     const formData = new FormData();
//     formData.append("name", data.categoryname);
//     formData.append("meta_title", data.metaTagTitle);
//     formData.append("meta_description", data.metaTagDescription);
//     formData.append("meta_keyword", data.metaTagKeywords);
//     formData.append("keyword", data.keywords);
//     formData.append("image", data.image);
//     formData.append("thumbnail", data.thumbnail);
//     formData.append("status", active);
//     formData.append("productId", JSON.stringify(data.productId));

//     try {
//       await dispatch(addCategory(formData)).unwrap();
//       toast.success("Category added successfully!");
//       navigate("/all-category");
//     } catch (error) {
//       toast.error(`Failed to add category: ${error.message}`);
//     }
//   };

//   // Fetch products once on mount
//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const res = await getData(`product/get-all-product?page=1&limit=1000`);
//         if (res.status === true) {
//           setProductList(res.data || []);
//         } else {
//           toast.error(res.message || "Failed to load products");
//         }
//       } catch (error) {
//         console.error("Error fetching products:", error);
//         toast.error("Error loading products");
//       }
//     };

//     fetchProducts();
//   }, []);

//   console.log("DATA:=>",data)
  
//   return (
//     <>
//       <ToastContainer />
//       <div className="bread">
//         <div className="head">
//           <h4>Add Category</h4>
//         </div>
//         <div className="links">
//           <Link to="/all-category" className="add-new">
//             Back <i className="fa-regular fa-circle-left"></i>
//           </Link>
//         </div>
//       </div>

//       <div className="d-form">
//         <form onSubmit={handleSubmit}>
//           <div className="row mb-3">
//             {/* Category Name */}
//             <div className="col-md-6 mt-2">
//               <label htmlFor="categoryname" className="form-label">
//                 Category Name <sup className="text-danger">*</sup>
//               </label>
//               <input
//                 type="text"
//                 id="categoryname"
//                 name="categoryname"
//                 className="form-control"
//                 value={data.categoryname}
//                 onChange={handleInputChange}
//                 placeholder="Enter category name"
//                 required
//               />
//             </div>

//             {/* Linked Products */}
//             <div className="col-md-6 mb-3">
//               <label htmlFor="productSelect" className="form-label">
//                 Link Products <sup className="text-danger">*</sup>
//               </label>

//               <Select
//                 inputId="productSelect"
//                 isMulti
//                 isSearchable
//                 name="productId"
//                 placeholder="Search and select products..."
//                 classNamePrefix="react-select"

//                 // Filter out already selected products from options
//                 options={productList.filter(
//                   (product) => !(data.productId || []).includes(product?.id)
//                 )
//                   .map((product) => ({
//                     value: product.id,
//                     label: product.name,
//                   }))
//                 }

//                 // Show selected products as selected values
//                 value={(data.productId || [])
//                   .map((id) => {
//                     const product = productList.find((p) => p?.id === id);
//                     return product
//                       ? { value: product.id, label: product?.name }
//                       : null;
//                   })
//                   .filter(Boolean)
//                 }

//                 // Handle selection
//                 onChange={(selectedOptions) => {
//                   // selectedOptions can be null if user clears selection
//                   const selectedIds = selectedOptions
//                     ? selectedOptions.map((opt) => opt.value)
//                     : [];
//                   setData((prev) => ({
//                     ...prev,
//                     productId: selectedIds,
//                   }));
//                 }}
//               />
//             </div>


//             {/* Meta Fields */}
//             <div className="col-md-6 mt-2">
//               <label htmlFor="metaTagTitle" className="form-label">
//                 Meta Tag Title <sup className="text-danger">*</sup>
//               </label>
//               <input
//                 type="text"
//                 id="metaTagTitle"
//                 name="metaTagTitle"
//                 className="form-control"
//                 value={data.metaTagTitle}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>

//             <div className="col-md-12 mt-2">
//               <label htmlFor="metaTagDescription" className="form-label">
//                 Meta Tag Description <sup className="text-danger">*</sup>
//               </label>
//               <input
//                 type="text"
//                 id="metaTagDescription"
//                 name="metaTagDescription"
//                 className="form-control"
//                 value={data.metaTagDescription}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>

//             <div className="col-md-6 mt-2">
//               <label htmlFor="metaTagKeywords" className="form-label">
//                 Meta Tag Keywords <sup className="text-danger">*</sup>
//               </label>
//               <input
//                 type="text"
//                 id="metaTagKeywords"
//                 name="metaTagKeywords"
//                 className="form-control"
//                 value={data.metaTagKeywords}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>

//             <div className="col-md-6 mt-2">
//               <label htmlFor="keywords" className="form-label">
//                 Keywords <sup className="text-danger">*</sup>
//               </label>
//               <input
//                 type="text"
//                 id="keywords"
//                 name="keywords"
//                 className="form-control"
//                 value={data.keywords}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>

//             {/* Images */}
//             <div className="col-md-6 mt-2">
//               <label htmlFor="image" className="form-label">
//                 Category Banner Image <sup className="text-danger">*</sup>
//               </label>
//               <input
//                 type="file"
//                 id="image"
//                 name="image"
//                 className="form-control"
//                 accept="image/*"
//                 onChange={handleFileChange}
//                 required
//               />
//             </div>

//             <div className="col-md-6 mt-2">
//               <label htmlFor="thumbnail" className="form-label">
//                 Category Thumbnail Image <sup className="text-danger">*</sup>
//               </label>
//               <input
//                 type="file"
//                 id="thumbnail"
//                 name="thumbnail"
//                 className="form-control"
//                 accept="image/*"
//                 onChange={handleFileChange}
//                 required
//               />
//             </div>

//             {/* Active Checkbox */}
//             <div className="col-md-6 d-flex align-items-center mt-3">
//               <input
//                 type="checkbox"
//                 id="active"
//                 checked={active}
//                 onChange={(e) => setActive(e.target.checked)}
//                 className="form-check-input"
//               />
//               <label htmlFor="active" className="form-check-label ms-2 mb-0">
//                 Active
//               </label>
//             </div>
//           </div>

//           <button type="submit" className="mybtnself" disabled={loading}>
//             {loading ? "Adding..." : "Add Category"}
//           </button>
//         </form>
//       </div>
//     </>
//   );
// };

// export default AddCategory;

import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addCategory } from "../../Slice/Category/categorySlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AsyncPaginate } from "react-select-async-paginate";
import { getData } from "../../services/FetchNodeServices";

const AddCategory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.category);
  const [productList, setProductList] = useState([]);
  const [active, setActive] = useState(false);
  const [data, setData] = useState({
    categoryname: "",
    metaTagTitle: "",
    metaTagDescription: "",
    metaTagKeywords: "",
    keywords: "",
    image: null,
    thumbnail: null,
    productId: [],
  });

  // Handle text input
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle file upload
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length && validateImage(files[0], name)) {
      setData((prev) => ({ ...prev, [name]: files[0] }));
    }
  };

  // Image validation (under 2MB)
  const validateImage = (file, label) => {
    if (!file) {
      toast.error(`Please select a ${label}`);
      return false;
    }
    if (file.size > 2 * 1024 * 1024) {
      toast.error(`${label} must be under 2MB`);
      return false;
    }
    return true;
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "categoryname",
      "metaTagTitle",
      "metaTagDescription",
      "metaTagKeywords",
      "keywords",
    ];

    for (let field of requiredFields) {
      if (!data[field]) {
        toast.error("Please fill all required fields");
        return;
      }
    }

    if (!validateImage(data.image, "Category Banner Image")) return;
    if (!validateImage(data.thumbnail, "Category Thumbnail Image")) return;

    const formData = new FormData();
    formData.append("name", data.categoryname);
    formData.append("meta_title", data.metaTagTitle);
    formData.append("meta_description", data.metaTagDescription);
    formData.append("meta_keyword", data.metaTagKeywords);
    formData.append("keyword", data.keywords);
    formData.append("image", data.image);
    formData.append("thumbnail", data.thumbnail);
    formData.append("status", active);
    formData.append("productId", JSON.stringify(data.productId));

    try {
      await dispatch(addCategory(formData)).unwrap();
      toast.success("Category added successfully!");
      navigate("/all-category");
    } catch (error) {
      toast.error(`Failed to add category: ${error.message}`);
    }
  };

  // Async load options for products with infinite scroll & search
  const loadProductOptions = async (search, loadedOptions, { page }) => {
    try {
      const res = await getData(`product/get-all-product?page=${page}&limit=20&search=${search || ""}`);
      if (res.status) {
        const newOptions = res.data.map((product) => ({
          value: product.id,
          label: product.name,
        }));

        return {
          options: newOptions,
          hasMore: res.data.length === 20,
          additional: { page: page + 1 },
        };
      } else {
        toast.error(res.message || "Failed to load products");
        return { options: [], hasMore: false };
      }
    } catch (error) {
      toast.error("Error loading products");
      console.error("Product fetch error:", error);
      return { options: [], hasMore: false };
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="bread">
        <div className="head">
          <h4>Add Category</h4>
        </div>
        <div className="links">
          <Link to="/all-category" className="add-new">
            Back <i className="fa-regular fa-circle-left"></i>
          </Link>
        </div>
      </div>

      <div className="d-form">
        <form onSubmit={handleSubmit}>
          <div className="row mb-3">
            {/* Category Name */}
            <div className="col-md-6 mt-2">
              <label className="form-label">
                Category Name <sup className="text-danger">*</sup>
              </label>
              <input
                type="text"
                name="categoryname"
                className="form-control"
                value={data.categoryname}
                onChange={handleInputChange}
                required
              />
            </div>

            {/* Linked Products with infinite scroll */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Link Products <sup className="text-danger">*</sup>
              </label>
              <AsyncPaginate
                inputId="productSelect"
                isMulti
                placeholder="Search and select products..."
                classNamePrefix="react-select"
                additional={{ page: 1 }}
                value={(data.productId || [])
                  .map((id) => {
                    const product = productList.find((p) => p?.id === id);
                    return product ? { value: product.id, label: product.name } : null;
                  })
                  .filter(Boolean)}
                loadOptions={loadProductOptions}
                onChange={(selectedOptions) => {
                  const selectedIds = selectedOptions
                    ? selectedOptions.map((opt) => opt.value)
                    : [];

                  setData((prev) => ({
                    ...prev,
                    productId: selectedIds,
                  }));

                  const allSelected = selectedOptions || [];
                  const allProducts = allSelected.map((opt) => ({
                    id: opt.value,
                    name: opt.label,
                  }));

                  setProductList((prevList) => {
                    const unique = [
                      ...prevList,
                      ...allProducts.filter((p) => !prevList.find((x) => x.id === p.id)),
                    ];
                    return unique;
                  });
                }}
              />
            </div>

            {/* Meta Fields */}
            <div className="col-md-6 mt-2">
              <label className="form-label">Meta Tag Title <sup className="text-danger">*</sup></label>
              <input
                type="text"
                name="metaTagTitle"
                className="form-control"
                value={data.metaTagTitle}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="col-md-12 mt-2">
              <label className="form-label">Meta Tag Description <sup className="text-danger">*</sup></label>
              <input
                type="text"
                name="metaTagDescription"
                className="form-control"
                value={data.metaTagDescription}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="col-md-6 mt-2">
              <label className="form-label">Meta Tag Keywords <sup className="text-danger">*</sup></label>
              <input
                type="text"
                name="metaTagKeywords"
                className="form-control"
                value={data.metaTagKeywords}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="col-md-6 mt-2">
              <label className="form-label">Keywords <sup className="text-danger">*</sup></label>
              <input
                type="text"
                name="keywords"
                className="form-control"
                value={data.keywords}
                onChange={handleInputChange}
                required
              />
            </div>

            {/* Images */}
            <div className="col-md-6 mt-2">
              <label className="form-label">Category Banner Image <sup className="text-danger">*</sup></label>
              <input
                type="file"
                name="image"
                className="form-control"
                accept="image/*"
                onChange={handleFileChange}
                required
              />
            </div>

            <div className="col-md-6 mt-2">
              <label className="form-label">Category Thumbnail Image <sup className="text-danger">*</sup></label>
              <input
                type="file"
                name="thumbnail"
                className="form-control"
                accept="image/*"
                onChange={handleFileChange}
                required
              />
            </div>

            {/* Active Toggle */}
            <div className="col-md-6 d-flex align-items-center mt-3">
              <input
                type="checkbox"
                id="active"
                checked={active}
                onChange={(e) => setActive(e.target.checked)}
                className="form-check-input"
              />
              <label htmlFor="active" className="form-check-label ms-2 mb-0">
                Active
              </label>
            </div>
          </div>

          <button type="submit" className="mybtnself" disabled={loading}>
            {loading ? "Adding..." : "Add Category"}
          </button>
        </form>
      </div>
    </>
  );
};

export default AddCategory;

